module.exports = __webpack_public_path__ + "static/media/cabo-af.136f0fdf.jpg";